import EventsTracking from '../../../../shared/eventsTracking.js';

export default {
  mounted() {
    const { taggingId } = this;

    this.tracking = new EventsTracking(taggingId);
  },
};
